var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navMenuView",style:({background:_vm.configOptions.containerBgColor ||''})},[_c('Input',{attrs:{"type":"text","readonly":"","size":"large","clearable":"","placeholder":"搜索关键字","autocomplete":"off"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }